import PropTypes from 'prop-types'
import { Alert, AlertDescription, AlertTitle } from '@components/ui/alert'
import { X } from 'lucide-react'
import { cn } from 'lib/utils'

export const AdasAlert = ({ children, severity = 'info', title, className, onClose, sx, ...props }) => (
  <Alert
    className={cn(
      'relative',
      severity === 'error' && 'border-error text-error bg-error/10',
      severity === 'warning' && 'border-warning text-warning bg-warning/10',
      severity === 'success' && 'border-success text-success bg-success/10',
      severity === 'info' && 'border-info text-info bg-info/10',
      className
    )}
    {...props}
  >
    {title && <AlertTitle>{title}</AlertTitle>}
    <AlertDescription>{children}</AlertDescription>
    {onClose && (
      <button onClick={onClose} aria-label='Close' className='absolute top-3 right-3 opacity-60 hover:opacity-100 transition-opacity'>
        <X className='w-4 h-4' />
      </button>
    )}
  </Alert>
)

AdasAlert.propTypes = {
  children: PropTypes.node,
  severity: PropTypes.oneOf(['error', 'warning', 'success', 'info']),
  title: PropTypes.string,
  className: PropTypes.string,
  onClose: PropTypes.func
}
